<div class="native-container">
  @if (nativeSoilData && nativeSoilData.length && nativeSoilData.length > 1) {
    <div class="savebtn">
      <button mat-raised-button color="primary" (click)="saveNativeSoil()">SAVE</button>
    </div>
  }
  <mat-tab-group animationDuration="0ms" (selectedTabChange)="onTabChange($event)">
    @for (tab of filteredTabs; track tab) {
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="tab-wrapper">
            <div class="tab-label" [class.active-tab]="isTabActive(tab.id)">{{ tab.tabName | uppercase }}</div>
            <div class="vertical-tab-indicator" [ngClass]="{ active: isTabActive(tab.id) }"></div>
          </div>
        </ng-template>
        @if (nativeSoilData && nativeSoilData.length && nativeSoilData.length > 1) {
          <app-admin-grid-table
            [dataSource]="nativeSoilData"
          [appRoles]="appRoles"></app-admin-grid-table>
        }
      </mat-tab>
    }
  </mat-tab-group>
</div>
